import moment from 'moment'

export const sizePerPageList = [
	{ text: "10", value: 10 },
	{ text: "20", value: 20 },
	{ text: "50", value: 50 }
];

export const initialFilter = {
	filter: {
		name: "",
		kd_cc: "",
		email: "",
		hp: "",
		city: "",
		provinsi: "",
		type: "",
		branch: "",
		start_date: moment().subtract(1, 'months'),
		end_date: moment(),
		is_letter: "",
		filterCabang: true
	},
	pageNumber: 1,
	pageSize: 10
};

// for popup donor filter in some component
export const initialFilterForChild = {
	filter: {
		name: "",
		kd_cc: "",
		email: "",
		hp: "",
		city: "",
		provinsi: "",
		type: "",
		branch: "",
		start_date: moment().subtract(1, 'months'),
		end_date: moment(),
		is_letter: "",
		filterCabang: false
	},
	pageNumber: 1,
	pageSize: 10
};

export const initUpdateBranch = {
	branch_uuid: '',
}

export const initialFilterDonasi = {
	filter: {
		trxDate: '',
		user_uuid: '',
		type_donor: '',
		donation_item_project: '',
		donation_item_type: '',
		donor_name: '',
		channel_uuid: '',
		start_date: '',
		end_date: '',
		status: '',
		total_amountlt: '',
		total_amountgt: '',
		donation_hid: ''
	},
	pageNumber: 1,
	pageSize: 10
};

export const initialFilterForParent = {
	filter: {
		name: "",
		type: "INDIVIDU"
	},
	pageNumber: 1,
	pageSize: 10
};

export const donaturTypeList = [
	{
		value: 'INDIVIDU',
		name: 'Individu'
	},
	{
		value: 'LEMBAGA',
		name: 'Lembaga'
	},
	{
		value: 'KOMUNITAS',
		name: 'Komunitas'
	},
]


export const isAlive = [
	{
		value: true,
		name: "Hidup"
	},
	{
		value: false,
		name: "Meninggal"
	}
]

export const greetingValue = [
	{
		value: "Bapak"
	}, {
		value: "Ibu"
	}, {
		value: "Mr."
	}, {
		value: "Mrs."
	}, {
		value: "Haji"
	}, {
		value: "Hajjah"
	},
]
export const isActive = [
	{
		value: true,
		name: "Aktif"
	},
	{
		value: false,
		name: "Non Aktif"

	},
]

export let type = [
	{
		value: "INDIVIDU",
		name: "Individu"
	},
	{
		value: "LEMBAGA",
		name: "Lembaga/Perusahaan"
	},
	{
		value: "KOMUNITAS",
		name: "Komunitas"
	},
]


export const jenisKelamin = [
	{
		value: "L",
		name: "Pria"
	},
	{
		value: "P",
		name: "Wanita"
	},
]

export const pendidikan = [
	{
		value: "SD",
		name: "SD"
	}, {
		value: "SMP",
		name: "SMP"
	}, {
		value: "SMA",
		name: "SMA"
	}, {
		value: "S1",
		name: "S1"
	}, {
		value: "S2",
		name: "S2"
	}, {
		value: "S3",
		name: "S3"
	},
]

export const letterChoice = [
	{
		value: true,
		name: "Ya"
	},
	{
		value: false,
		name: "Tidak"

	},
]

export let initDonatur = {
	name: '',
	hp: '',
	email: '',
	province: '',
	city: '',
	district: '',
	postal_code: '',
	address: '',
	npwp: '',
	npwz: '',
	nik: '',
	is_alive: '',
	is_active: '',
	greeting: '',
	type: '',
	kode_rekening: '',
	pic: '',
	pic_hp: '',
	pic_email: '',
	parent_uuid: ''
};

export const initDonaturProfile = {
	jenis_kelamin: '',
	pendidikan: '',
	pekerjaan: '',
	tanggal_lahir: undefined,
}

export const initDonaturPassword = {
	password: '',
	cPassword: ''
}

export const initLetter = [
	{
		value: '',
		name: "-PILIH-"
	},
]

export const isActiveLabel = (status) => {
	let data = {};
	if (status) {
		data = {
			type: 'success',
			name: 'ACTIVE'
		}
	} else {
		data = {
			type: 'danger',
			name: 'NON ACTIVE'
		}
	}

	return data;
};

export const badge = (status) => {
	let data = {};
	switch (status) {
		case 'VOID':
			data = { type: 'danger' };
			break;
		case 'REQUEST_VOID':
			data = { type: 'warning' };
			break;
		case 'SETTLE':
			data = { type: 'success' };
			break;
		default:
			data = { type: 'info' };

	}

	return data;
};